import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserAPIService } from '../../extensions/services/api/user-api.service';
import { TenantAPIService } from 'src/app/extensions/services/api/tenant-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';

@Injectable({ providedIn: 'root' })
export class StartupService {
  public constructor(
    private _userAPIService: UserAPIService,
    private _tenantApiService: TenantAPIService,
    private _globalService: GlobalService
  ) {}

  public async init(): Promise<void> {
    const [userProfile, subTenants] = await Promise.all([this.loadUserProfile(), this.loadCurrentUserSubTenants()]);

    this._globalService.user = userProfile;
    this._globalService.subTenants = subTenants;

    const currentId = this._globalService.subTenant?.id;

    this._globalService.subTenant =
      subTenants.find(x => x.id === currentId) ?? subTenants.find(x => x.default) ?? subTenants[0] ?? null;
  }

  private loadUserProfile() {
    return firstValueFrom(this._tenantApiService.getUserProfile());
  }

  private loadCurrentUserSubTenants() {
    return firstValueFrom(this._userAPIService.getCurrentUserSubTenants());
  }
}
